import NO05, { NO05StatusStat } from '../../models/NO05';
import * as actionTypes from '../actions/actionTypesNO05';

export interface NO05State {
  stats: NO05StatusStat[];
  statsLoading: boolean;
  statsError: string | null;
  selectedStatus: string;
  orders: NO05[];
  loading: boolean;
  loadingMore: boolean;
  error: string | null;
  currentPage: number;
  pageSize: number;
  hasMore: boolean;
  lastSearchParams: any;
  isResetFormEnabled: boolean;
  orderDetail: any | null;
  orderDetailLoading: boolean;
  selectAllTick: number;
  selectedOrderNrs: string[];
}

const initialState: NO05State = {
  stats: [],
  statsLoading: false,
  statsError: null,
  selectedStatus: 'Alle ordre',
  orders: [],
  loading: false,
  loadingMore: false,
  error: null,
  currentPage: 0,
  pageSize: 30,
  hasMore: true,
  lastSearchParams: null,
  isResetFormEnabled: false,
  orderDetail: null,
  orderDetailLoading: false,
  selectAllTick: 0,
  selectedOrderNrs: [],
};

const NO05Reducer = (state = initialState, action: any): NO05State => {
  switch (action.type) {
    case actionTypes.NO05_STATS_REQUEST:
      return { ...state, statsLoading: true, statsError: null };
    case actionTypes.NO05_STATS_SUCCESS:
      return { ...state, statsLoading: false, stats: action.payload };
    case actionTypes.NO05_STATS_FAILURE:
      return { ...state, statsLoading: false, statsError: action.payload };

    case actionTypes.NO05_SET_STATUS:
      return { ...state, selectedStatus: action.payload };

    case actionTypes.NO05_SEARCH_REQUEST:
      return { ...state, loading: true, error: null, currentPage: 0, lastSearchParams: action.payload, selectedOrderNrs: [] };
    case actionTypes.NO05_SEARCH_SUCCESS:
      return { ...state, loading: false, orders: action.payload.orders, hasMore: action.payload.hasMore, currentPage: 0, error: null };
    case actionTypes.NO05_SEARCH_FAILURE:
      return { ...state, loading: false, error: action.payload, orders: [], hasMore: false };

    case actionTypes.NO05_LOAD_MORE_REQUEST:
      return { ...state, loadingMore: true, error: null };
    case actionTypes.NO05_LOAD_MORE_SUCCESS:
      return { ...state, loadingMore: false, orders: [...state.orders, ...action.payload.orders], hasMore: action.payload.hasMore, currentPage: state.currentPage + 1, error: null };
    case actionTypes.NO05_LOAD_MORE_FAILURE:
      return { ...state, loadingMore: false, error: action.payload };

    case actionTypes.NO05_SELECT_ALL:
      return { ...state, selectAllTick: state.selectAllTick + 1 };
    case actionTypes.NO05_SET_SELECTED:
      return { ...state, selectedOrderNrs: action.payload };

    case actionTypes.NO05_CLEAR_RESULTS:
      return { ...state, orders: [], stats: [], error: null, hasMore: true, currentPage: 0, lastSearchParams: null, selectAllTick: 0, selectedOrderNrs: [] };
    case actionTypes.NO05_RESET_FORM:
      return { ...initialState, isResetFormEnabled: action.payload };
    case actionTypes.NO05_CLEAR_COMPONENT_STORE:
      return { ...initialState };

    case actionTypes.NO05_ORDER_DETAIL_REQUEST:
      return { ...state, orderDetailLoading: true, orderDetail: null };
    case actionTypes.NO05_ORDER_DETAIL_SUCCESS:
      return { ...state, orderDetailLoading: false, orderDetail: action.payload };
    case actionTypes.NO05_ORDER_DETAIL_FAILURE:
      return { ...state, orderDetailLoading: false };
    case actionTypes.NO05_ORDER_DETAIL_CLEAR:
      return { ...state, orderDetail: null, orderDetailLoading: false };

    default:
      return state;
  }
};

export default NO05Reducer;
